import React, { FC } from "react";
import { Control } from "react-hook-form";

import NumbersBase, { NumbersBaseProps } from "@/components/ui/Form/Filters/components/Numbers/NumbersBase";
import NumbersControlled from "@/components/ui/Form/Filters/components/Numbers/NumbersControlled";

export interface NumberProps extends NumbersBaseProps {
  control?: Control<any>;
}
const FilterNumber: FC<NumberProps> = (args) => {
  return <>{args?.control ? <NumbersControlled control={args.control} {...args} /> : <NumbersBase {...args} />}</>;
};
export default FilterNumber;
